import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const saloons = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
    },
    selectedItems: [],
    loading: true,
  }),
  mutations: {
    setSaloons(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedSaloons(state, payload) {
      state.selectedItems = payload;
    },
    setSaloonPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getSaloons");
    },
    setSaloonTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getSaloons");
    },
  },
  actions: {
    async getSaloons(store) {
      store.state.loading = true;
      await axios
        .post("saloon/load", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setSaloons", res.data.data);
        });
    },
    async toggleSaloon(store, payload) {
      var res = await axios.post("saloon/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteSaloon(store, payload) {
      await axios
        .post("saloon/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setSaloonPage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default saloons;



// WEBPACK FOOTER //
// ./src/store/saloons.js